<template>
    <div>
        <div class="page-header">
            <h1 class="page-title">{{$t('products.products')}}</h1>

            <div>
                <a href="#" class="btn btn--primary" @click.prevent="$router.push({name: 'products.create'})">
                    {{ $t('products.add_product') }}
                </a>
            </div>
        </div>

        <div class="filters">
            <div class="search">
                <img src="/svgs/search-icon.svg" alt="search-icon">
                <input class="search"
                       type="text"
                       :placeholder="$t('general.search') + '...'"
                       v-model="searchQuery"
                       @input="onSearchInput" />
                <div class="multiselect__spinner" v-if="loadingProducts"/>
            </div>
        </div>

        <table class="table" ref="overviewTable">
            <thead>
                <tr>
                    <th class="status">{{ $t('products.status') }}</th>
                    <th>{{ $t('products.name') }}</th>
                    <th></th>
                    <th>{{ $t('products.price_indication') }}</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="product in products" :key="product.id" @click="showDetail(product)">
                    <td class="status">{{ product.isVisible }}
                        <div class="indicator" :class="{'green': product.is_visible,'red': !product.is_visible}" />
                    </td>
                    <td>{{ product.name }}</td>
                    <td>
                        <span v-if="product.filters_with_label.length > 0" class="product-label">{{ firstProductLabel(product.filters_with_label) }}</span>
                    </td>
                    <td>€ {{ product.calculated_price.toFixed(2) }}</td>
                </tr>
            </tbody>
        </table>

        <div class="pagination pagination--push-top" v-if="totalPages > 1">
            <span @click="paginate(n)" v-for="n in paginationPages" :class="{'active' : n === page}">{{ n }}</span>
        </div>
    </div>
</template>

<script>
    import { ProductService } from '../../services';
    import debounce from 'lodash/debounce';
    import axios from 'axios';

    export default {
        name: 'overview-product',

        data() {
            return {
                products: {},
                searchQuery: '',
                page: 1,
                totalPages: 1,
                cancelToken: null,
                loadingProducts: false,
            }
        },

        computed: {
            paginationPages() {
                const totalPages = this.totalPages;
                const page = this.page;
                const pages = 17;

                let lowerLimit = Math.min(page, totalPages);
                let upperLimit = Math.min(page, totalPages);

                for (let b = 1; b < pages && b < totalPages;) {
                    if (lowerLimit > 1) {
                        lowerLimit--;
                        b++;
                    }

                    if (b < pages && upperLimit < totalPages) {
                        upperLimit++;
                        b++;
                    }
                }

                if (lowerLimit === 0 || upperLimit === 0) {
                    return [];
                }

                return Array(upperLimit - lowerLimit + 1).fill().map((_, idx) => lowerLimit + idx);
            },
        },

        methods: {
            fetchProducts() {
                if (this.cancelToken !== null) {
                    this.cancelToken.cancel();
                }

                this.cancelToken = axios.CancelToken.source();

                this.loadingProducts = true;

                const params = {
                    page: this.page,
                    filters: {
                        name: this.searchQuery,
                    }
                };

                const options = {
                    cancelToken: this.cancelToken.token
                };

                const promise = ProductService.index(params, options);

                promise.then(response => {
                    this.page = response.data.current_page;
                    this.totalPages = response.data.last_page;
                    this.products = response.data.data;
                    this.loadingProducts = false;
                });

                return promise;
            },

            onSearchInput: debounce(function () {
                let promise = this.fetchProducts();
                promise.then(() => {
                    this.resetPagination();
                });
            }, 350),

            paginate(page) {
                this.page = page;
                this.fetchProducts().then(response => {
                    const table = this.$refs.overviewTable;
                    table.scrollIntoView({ behavior: 'smooth' });
                });
            },

            resetPagination() {
                this.page = 1;
            },

            showDetail(product) {
                this.$router.push('producten/' + product.id)
            },

            firstProductLabel(filters) {
                return filters[0].option;
            }
        },

        beforeMount() {
            this.fetchProducts();
        }
    }
</script>
